import { type BaseProduct, type Product } from 'domains/products/components/view/utils/types'
import { useGetProductMeshQuery, type GetProductMeshQueryVariables } from 'domains/products/api'

const processProduct = (product: BaseProduct): Product => {
  if (!product) return null

  const aisles = product.aisles?.map(aisle => {
    const department = product.departments?.find(d => d.id === aisle.departmentId)

    return { ...aisle, department }
  })

  return { ...product, aisles, aisle: aisles?.find(a => a.id === product.primaryAisleId) }
}

export const useGetProductMesh = (variables: GetProductMeshQueryVariables) => {
  const {
    data,
    error: apiError,
    loading: apiLoading,
    refetch: apiRefetch,
  } = useGetProductMeshQuery({
    variables,
  })

  const product = data?.retailerToolsServiceGetRetailerProducts?.results?.[0]

  return {
    product: processProduct(product),
    apiError,
    apiLoading,
    apiRefetch,
  }
}
